import { CampaignTriggers, CampaignTypes } from "types/campaigns";
import { ExportType } from "types/exports";

export const genderList = ["female", "male", "not_disclosed"] as const;
export const pointsTransfersTypes = [
  "adding",
  "blocked",
  "expired",
  "p2p_adding",
  "p2p_spending",
  "spending",
] as const;
export const pointsTransfersState = [
  "active",
  "canceled",
  "expired",
  "pending",
] as const;
export const rewardTypes = [
  "material",
  "conversion_coupon",
  "static_coupon",
  "dynamic_coupon",
] as const;
export const rewardFulfillmentStatus = [
  "approved",
  "canceled",
  "completed",
  "issued",
  "packing",
  "pending",
  "rejected",
  "returned",
  "shipped",
  "awaiting_shipping",
] as const;
export const handledCampaignTypes = [
  CampaignTypes.DIRECT,
  CampaignTypes.REFERRAL,
] as const;
export const statusValue = {
  SUCCEED: "succeed",
  DONE: "done",
  ERROR: "error",
  IN_PROGRESS: "inprogress",
  FAILED: "failed",
  QUEUED: "queued",
  PENDING: "pending",
} as const;
export const importDetailsStatus = [
  { id: statusValue.SUCCEED, label: "successfullyImported" },
  { id: statusValue.FAILED, label: "failedToImport" },
] as const;
export const handledCampaignTriggers = [
  { id: CampaignTriggers.TRANSACTION, label: "purchase" },
  { id: CampaignTriggers.RETURN_TRANSACTION, label: "return" },
  { id: CampaignTriggers.CUSTOM_EVENT, label: "customEvent" },
  { id: CampaignTriggers.INTERNAL_EVENT, label: "internalEvent" },
  { id: CampaignTriggers.CUSTOM_EVENT_UNIQUE_CODE, label: "redemptionCode" },
  { id: CampaignTriggers.ACHIEVEMENT, label: "achievement" },
  { id: CampaignTriggers.TIME, label: "time" },
] as const;
export const handledExportTypes = [
  { id: ExportType.MEMBER, label: "members" },
  { id: ExportType.CAMPAIGN_CODE, label: "redemptionCodes" },
  { id: ExportType.MEMBER_SEGMENT, label: "membersSegment" },
  { id: ExportType.MEMBER_TIER, label: "membersTier" },
] as const;
export const surveyQuery = "?survey=true";
